import { DirectiveType } from '../../types';
import { AbstractSingleValueDirective } from '../abstract-single-value-directive';
export class ReportTo extends AbstractSingleValueDirective {
    getDirectiveName() {
        return 'report-to';
    }
    getDirectiveType() {
        return DirectiveType.Reporting;
    }
}
